/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,

  //baseUrl
  // baseUrl:'https://core.carefluence.com/cf.admin.core.stg/',
  // baseUrlNotDev: 'https://core.carefluence.com/cf.admin.core.stg/',

  //subUrl
  apiUrl: '__API_BASE_URL__/',
  fhiropsUrl: '__API_FHIROPS_URL__/'
};
